import logo from './logo.svg';
import './App.less';
import TimeTracker from 'react-time-tracker-stopwatch';

function App() {
  const onSave =( totalTime) => {
    console.log('Total time spent by user', totalTime);
  }
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>

        <TimeTracker
          onTimeUpdate={(...args) => console.log(args)}
        />

      </header>
    </div>
  );
}

export default App;
